<template>
    <div class="vue-container container" :class="[$common.lang]">
		<div class="header-bg" @click="showLanguages=!showLanguages"></div>
		<div class="lrspace user">
			<!-- logged -->
			<div class="profile" v-if="$common.accessToken" @click="logout">
				<div class="photo">
					<img v-if="userInfo('avatar')" :src="userInfo('avatar')" />
				</div>
				<div class="name">{{userInfo('username')}}</div>
			</div>
			<!-- not logged -->
			<div class="profile" v-if="!$common.accessToken" @click="login">
				<div class="photo not-login"></div>
				<div class="name">{{$t('注册/登录')}}</div>
			</div>
			<div class="language">{{$common.languages[$common.lang]}} <span class="more"></span></div>
		</div>
		<div class="card">
			<div class="logo"></div>
			<div class="count">{{userTotal}}</div>
			<!-- <div class="desc">{{$t('学习最地道的中文')}}</div> -->
		</div>
		<div class="content">
			<div class="lrspace title">{{$t('VIP套餐')}}</div>
			<div class="lrspace product">
				<div class="product-title">{{$t('{N}个月', {num:product.type})}}</div>
				<div class="right">
					<div class="price">
						<span class="unit">¥</span>{{product.price}}</div>
					<div class="original-price">¥{{product.original}}</div>
				</div>
				<div class="save">{{$t('节省{%}', {percent:product.percent})}}</div>
			</div>
			<div class="lrspace buy-botton" @click="showPayments=!showPayments">{{$t('立即购买')}}</div>
			<div ref="agree" class="lrspace agree" v-html="$t('点击购买/续费即表示您已阅读并同意《自动续费服务规则》、《服务使用协议》、《用户隐私协议》')"></div>
			<div class="interval"></div>
			<div class="lrspace title">{{$t('畅学600+超级进阶课程')}}</div>
			<div class="lrspace sub-title">
				<div class="quotation"></div>{{$t('超20年资深教研团队倾心编写')}}
			</div>
			<div class="lrspace lesson lesson-a">
				<div class="lesson-photo"></div>
				<div>
					<div class="lesson-title">{{$t('词汇')}}</div>
					<div class="lesson-desc">{{$t('选取高频词汇，学以致用')}}<br />{{$t('全方位训练听、说、读、写')}}</div>
				</div>
			</div>
			<div class="lrspace lesson lesson-b">
				<div class="lesson-photo"></div>
				<div>
					<div class="lesson-title">{{$t('语法')}}</div>
					<div class="lesson-desc">{{$t('科学系统的语法知识体系')}}<br />{{$t('掌握语法结构，灵活运用')}}</div>
				</div>
			</div>
			<div class="lrspace lesson lesson-c">
				<div class="lesson-photo"></div>
				<div>
					<div class="lesson-title">{{$t('课文')}}</div>
					<div class="lesson-desc">{{$t('100+ 日常话题，沉浸式中文学习体验')}}<br />{{$t('AI引擎智能打分，从此大胆开口说中文')}}</div>
				</div>
			</div>
			<div class="lrspace lesson lesson-d">
				<div class="lesson-photo"></div>
				<div>
					<div class="lesson-title">{{$t('小测试')}}</div>
					<div class="lesson-desc">{{$t('检验课程内容的学习情况')}}<br />{{$t('定位薄弱项，给出学习推荐')}}</div>
				</div>
			</div>
			<div class="interval"></div>
			<div class="lrspace title">{{$t('智能AI引擎为你保驾护航')}}</div>
			<div class="ais">
				<div class="lrspace ai ai-a">
					<div class="ai-photo"></div>
					<div class="ai-desc">{{$t('个性化学习推荐，由浅入深系统学习')}}</div>
				</div>
				<div class="lrspace ai ai-b">
					<div class="ai-photo"></div>
					<div class="ai-desc">{{$t('独家AI算法分析，科学安排复习')}}</div>
				</div>
				<div class="lrspace ai ai-c">
					<div class="ai-photo"></div>
					<div class="ai-desc">{{$t('智能错题收集，帮你查漏补缺')}}</div>
				</div>
				<div class="automan"></div>
			</div>
			<div class="interval clear"></div>
			<div class="lrspace title">{{$t('VIP专属特权')}}</div>
			<table class="lrspace rights">
				<thead>
					<tr>
						<th>{{$t('功能特权')}}</th>
						<th class="vip">{{$t('VIP')}}</th>
						<th class="normal">{{$t('普通用户')}}</th>
					</tr>
				</thead>
				<tr>
					<td>{{$t('词汇')}}</td>
					<td><span class="right"></span></td>
					<td>{{$t('体验')}}</td>
				</tr>
				<tr class="even">
					<td>{{$t('语法')}}</td>
					<td><span class="right"></span></td>
					<td>{{$t('体验')}}</td>
				</tr>
				<tr>
					<td>{{$t('课文')}}</td>
					<td><span class="right"></span></td>
					<td>{{$t('体验')}}</td>
				</tr>
				<tr class="even">
					<td>{{$t('小测试')}}</td>
					<td><span class="right"></span></td>
					<td><span class="wrong"></span></td>
				</tr>
				<tr>
					<td>{{$t('知识库')}}</td>
					<td><span class="right"></span></td>
					<td><span class="right"></span></td>
				</tr>
				<tr class="even">
					<td>{{$t('Flashcard')}}</td>
					<td><span class="right"></span></td>
					<td><span class="wrong"></span></td>
				</tr>
				<tr>
					<td>{{$t('收藏')}}</td>
					<td><span class="right"></span></td>
					<td><span class="wrong"></span></td>
				</tr>
			</table>
			<div class="interval"></div>
			<div class="lrspace title">{{$t('用户反馈')}}</div>
			<section class="comments">
				<van-swipe :loop="false" :width="commentWidth" ref="swipe" :show-indicators="false">
					<van-swipe-item v-for="(comment,index) in comments" :key="comment.name" :style="{'margin-left': index==0? commentTranslateX+'px':'','transition-duration':'300ms'}">
						<div class="item" style="margin:0 0.533333rem;" ref="comment">
							<div class="user-profile">
								<div class="user-avatar">
									<img :src="comment.avatar ? cdn(comment.avatar) : null">
								</div>
								<div class="user-info">
									<div class="name">{{comment.name}}</div>
									<div class="country">{{comment.location}}</div>
									<div class="time" v-html="$t('学习{N}天',{'day':comment.study})"></div>
								</div>
							</div>
							<div class="learn-info">
								<div class="desc">
									<div class="learn-title">{{$t('初始水平')}}</div>
									<div>LV {{comment.startLevel}}</div>
								</div>
								<div class="up-to"></div>
								<div class="desc">
									<div class="learn-title">{{$t('目前水平')}}</div>
									<div>LV {{comment.currentLevel}}</div>
								</div>
							</div>
							<div class="comment-content">
								{{comment.summary}}
							</div>
						</div>
					</van-swipe-item>
					<van-swipe-item></van-swipe-item>
				</van-swipe>
			</section>
		</div>
		<div class="bottom">
			<div class="buy">
				<div class="product">
					<div class="price">
						<span class="unit">¥</span>{{product.price}}
						<div class="original-price">/{{$t('{N}个月', {num:product.type})}}</div>
					</div>
					<div class="buy-botton" @click="showPayments=!showPayments">{{$t('立即购买')}}</div>
				</div>
			</div>
		</div>
		<!-- top -->
		<div class="top" @click="scrollTo(0,0)"></div>
		<!-- openOtherBroswer -->
		<div class="open-other-broswer" v-show="showOpenOtherBroswer">
			<div class="mask" @click="showOpenOtherBroswer=!showOpenOtherBroswer"></div>
			<div class="arrow"></div>
			<div class="contents">
				<div class="text" v-html="$t('点击右上角的按钮,选择在浏览器中打开')"></div>
			</div>
		</div>
		<!-- payments -->
		<van-popup v-model="showPayments" position="bottom" style="border-radius: 0.373333rem 0.373333rem 0 0;">
			<div class="lrspace payments">
				<div class="title">{{$t('选择支付方式')}}</div>
				<ul>
					<van-radio-group v-model="payment">
					<li v-for="payment in payments" class="payment wechat" :class="[payment.payment]" @click="changePayment(payment)">
						<div class="name">
							<div class="logo" :class="['logo-'+payment.payment]"></div>
							<span>{{$t(payment.name)}}</span>
						</div>
						<div class="check">
							<van-radio :name="payment.payment" checked-color="#FD8C1F"></van-radio>
						</div>
					</li>
					</van-radio-group>
				</ul>
				<div class="buy-botton" @click="pay()">{{$t('立即支付')}}</div>
			</div>
		</van-popup>
		<!-- languages -->
		<van-popup v-model="showLanguages" style="border-radius: 0.373333rem;">
			<div class="languages">
				<ul>
					<li v-for="(item, key) in $common.languages" @click="selectLanguage(key)">{{item}}</li>
				</ul>
			</div>
		</van-popup>
		<!-- privacy -->
		<van-popup 
		v-model="showPrivacy"
		:style="{
			height: '80%',
			width: '80%',
			borderRadius:'0.2rem'
		}">
			<div style="padding: 0.533333rem 0;">
				<iframe id="privacy" style="width:100%; height:100vh;" scrolling="auto" frameborder="0" :src="fullUrl('privacy')"></iframe>
			</div>
		</van-popup>
		<!-- protocol -->
		<van-popup 
		v-model="showProtocol"
		:style="{
			height: '80%',
			width: '80%',
			borderRadius:'0.2rem'
		}">
			<div style="padding: 0.533333rem 0;">
				<iframe id="protocol" style="width:100%; height:100vh;" scrolling="auto" frameborder="0" :src="fullUrl('protocol')"></iframe>
			</div>
		</van-popup>
		<!-- autopay -->
		<van-popup v-model="showAutopay"
		:style="{
			height: '80%',
			width: '80%',
			borderRadius:'0.2rem'
		}">
			<div style="padding: 0.533333rem 0;">
				<iframe id="autopay" style="width:100%; height:100vh;" scrolling="auto" frameborder="0" :src="fullUrl('autopay')"></iframe>
			</div>
		</van-popup>
		<!--Begin Login Test-->
		<van-popup v-model="showUserForm" style="border-radius: 0.373333rem;width:90%;">
			<UserForm @finish="handleUserFinish"></UserForm>
		</van-popup>
		<!--End Login Test-->
    </div>
</template>
<script>
import {
    getQueryString,
    invokeApp,
    setStorage,
    getStorage,
    clearStorage,
    removeStorage,
} from "@/util";
import languageMixin from '@/mixins/language'
import loginMixin from '@/mixins/login'
import globalMixin from '@/mixins/global'
import { 
	Toast, 
	Dialog, 
	Loading,
	Popup,
	Radio,
} from "vant";
import UserForm from '@/components/user'
export default {
    name: "index",
    mixins: [
		languageMixin,
		loginMixin,
		globalMixin
	],
	components: {
		UserForm
	},
    data() {
        return {
			showPayments:false,
			showPrivacy:false,
			showProtocol:false,
			showAutopay:false,
			showUserForm:false,
			showOpenOtherBroswer:false,
			payment:'wechat',
			payments:[
				{
					name:this.$t('微信'),
					aliase:'weixin',
					payment:'wechat',
					channel:'tenpay_cn',
				},
				{
					name:this.$t('支付宝'),
					aliase:'alipay',
					payment:'alipay',
					channel:'alipay_cn',
				}
			],
			comments:[],
			product:{
				price:0,
				original:720,
				percent:'0%',
				type:'12'
			},
			form:{
				payment:null,
				channel:null,
				currency:'¥',
				proxy_code:getStorage('proxy_code'),
				created_from:getStorage('os')+'-proxy-'+getStorage('proxy_code'),
				return_url:this.$common.apis["return"],
			},
			userTotal:0,
			commentWidth: window.screen.width * 0.8,
			commentTranslateX: (window.innerWidth - this.commentWidth) / 2,
        };
    },
    created() {
    },
	mounted(){
		var that = this
		if(!getStorage('proxy_code')){
			Toast('error code')
			return 
		}
		window.privacy = function(){
			return that.privacy()
		}
		window.protocol = function(){
			return that.protocol()
		}
		window.autopay = function(){
			return that.autopay()
		}
		this.loadComments()
		this.loadProduct()
		this.loadTotalNum()
		this.changePayment(this.payments[0])
		this.addView()
	},
    watch: {
    },
    methods: {
		addView(){
			this.$fetch(this.$common.apis.browse).then(res => {})
		},
		scrollTo(x,y){
			window.scrollTo(x, y)
		},
		changePayment(payment){
			this.payment = payment.payment
			this.form.payment = payment.aliase
			this.form.channel = payment.channel
		},
		login(){
			if(this.$common.inWechat){
				this.openOtherBroswer()
				return
			}
			this.showUserForm = true
		},
		openOtherBroswer(){
			this.showOpenOtherBroswer = true
			document.getElementsByClassName('mask')[0].style.height = window.innerHeight + "px"
		},
		pay(){
			if(!getStorage('proxy_code')){
				Toast('error code')
				return 
			}
			if(this.$common.inWechat){
				this.openOtherBroswer()
				return
			}
			if(!this.$common.accessToken){
				this.login()
				return
			}
			this.$post(this.$common.apis['order'], this.form).then(data => {
				if (data.status == 3) {
					Toast(this.$t('支付失败'))
					console.log('createOrderFailed',this.form, data)
				    return
				}
				setStorage('number', data.number)
				var request = null
				switch (this.form.payment) {
				    case 'alipay':
				        request = data.alipay_request
				        break;
				    case 'weixin':
				        request = data.weixin_request
				        break;
				    case 'paypal':
				        request = data.paypal_request
				        break;
				    default:
				        request = data.payssion_request
				        break;
				}
				if (request.type == 'redirect') {
					if(getStorage("os") == 'IOS'){
						window.location.href=request.url
					}else{
						window.open(request.url)
					}
					Dialog.confirm({
					        title: null,
					        message: this.$t("确定支付完成了吗?"),
					        confirmButtonText: this.$t("我已支付完成"),
					        cancelButtonText: this.$t("重新支付"),
					    })
					    .then(() => {
							this.$router.push({
							    path: '/result'
							})
					    })
					    .catch(() => {
							// repay
					    })
				} else {
					console.log('requestTypeError',this.form, data)
				}
			})
		},
		loadComments(){
			this.$fetch(this.$common.apis.comments).then(res => {
				this.comments = res.items
			})
		},
		handleUserFinish(res) {
			//登录或注册成功后的事件
			this.$common.accessToken = res.user.access_token
			setStorage('access_token', res.user.access_token)
			setStorage('user_info', res.user)
			this.showUserForm = false
			this.$fetch(this.$common.apis.userBind+'?productType=2&uid='+this.userInfo("uid")).then(res => {})
		},
		loadProduct(){
			this.$fetch(this.$common.apis.product).then(res => {
				this.product.price = parseFloat(res.data)
				this.product.percent = parseInt((this.product.original - this.product.price) / this.product.original * 100) + '%'
			})
		},
		loadTotalNum(){
			this.$fetch(this.$common.apis.vip).then(res => {
				this.userTotal = res.purchasers.user_total
			})
		},
		fullUrl(apiKey){
			return this.$common.apiBaseURL + this.$common.apis[apiKey] + '?lang='+this.$common.lang
		},
		privacy(){
			this.showPrivacy = !this.showPrivacy
		},
		protocol(){
			this.showProtocol = !this.showProtocol
		},
		autopay(){
			this.showAutopay = !this.showAutopay
		}
  },
};
</script>
<style lang="stylus" scoped="scoped">
	.lrspace{
		margin-left 0.533333rem
		margin-right 0.533333rem
	}
	.clear{
		clear both
	}
	.text-left{
		text-align left
	}
	.container{
		background: linear-gradient(135deg, #FEB040 0%, #FF6F1C 100%);
		padding-top 0.533333rem
		.languages{
			padding 0.533333rem
			font-size 0.373333rem
			& ul{
				& li{
					padding 0.266666rem
					text-align center
				}
			}
		}
		.payments{
			background: #FFFFFF;
			border-radius: 0.32rem 0.32rem 0 0;
			padding-top 0.533333rem
			padding-bottom 0.96rem
			.payment{
				display flex
				justify-content space-between
				align-items center
				border-bottom 0.026666rem solid #EDEEF0
				padding-bottom 0.426666rem
				margin-bottom 0.426666rem
				&:last-child{
					border-bottom none
					padding-bottom 0
					margin-bottom 0
				}
				.name{
					display flex
					align-items center
					font-size: 0.426666rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #2D363E;
					span{
						margin 0 0.32rem
						display inline-block
					}
					.logo{
						width 0.853333rem
						height 0.853333rem
						background-size contain
						&.logo-wechat{
							background-image url(../assets/img/24.png)
						}
						&.logo-alipay{
							background-image url(../assets/img/25.png)
						}
					}
				}
			}
			.buy-botton{
				margin 1.333333rem auto 0 auto
				width: 8.933333rem;
				height: 1.28rem;
				background: linear-gradient(90deg, #FEB040 0%, #FD6A00 100%);
				border-radius: 0.64rem;
				font-size: 0.48rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				display flex
				justify-content center
				align-items center
			}
		}
		.open-other-broswer{
			position fixed
			top 100px
			width 100%
			z-index 3000
			.mask{
				background-color #000
				opacity 0.3
				width 100%
				height 300px
				top -100px
				z-index -1
				position absolute
				
			}
			.arrow{
				width 1.226666rem
				height 2.4rem
				background-image url(../assets/img/29.png)
				background-size contain
				position absolute
				right 0
				top -95px
			}
			.contents{
				width 100%
				display flex
				justify-content center
				.text{
					color white
					width 8.933333rem
					min-height 1.44rem
					background-color #000000
					border-radius 0.32rem
					opacity 0.7
					display flex
					justify-content center
					align-items center
					font-size 0.426666rem
				}
			}
		}
		.top{
			width 1.066666rem
			height 1.066666rem
			background-image url(../assets/img/23.png)
			background-size contain
			position fixed
			bottom 1.733333rem
			right 0.133333rem
			&.not-login{
				bottom 0.1rem
			}
		}
		.interval{
			height 0.24rem
			width 100%
			background #F8F8F9
		}
		.header-bg{
			width 3.6rem
			height 2.213333rem
			background url(../assets/img/1.png) no-repeat
			background-size contain
			background-position center
			position absolute
			right 0
			top 0
		}
		.title{
			font-size: 0.533333rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #2D363E;
			line-height: 0.746666rem;
			margin-top 0.533333rem
			margin-bottom 0.533333rem
		}
		.sub-title{
			font-size: 0.373333rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #989EA4;
			line-height: 0.693333rem;
			position relative
		}
		.user{
			display flex
			align-items center
			justify-content space-between
			.profile{
				display flex
				align-items center
				.photo{
					background-image url(../assets/img/2.png)
					width 0.64rem
					height 0.64rem
					background-size contain
					margin 0.106666rem
					& img{
						width 0.64rem
						height 0.64rem
						border-radius 1rem
					}
					&.not-login{
						background-image url(../assets/img/26.png)
					}
				}
				.name{
					max-width: 4.16rem;
					font-size: 0.373333rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 0.533333rem;
				}
			}
			.language{
				display flex
				align-items center
				font-size: 0.373333rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				.more{
					height 0.16rem
					width 0.24rem
					background url(../assets/img/3.png) no-repeat
					background-size contain
					display inline-block
					margin-left 0.133333rem
				}
			}
		}
		.card{
			width 7.866666rem
			height 1.826666rem
			padding 0.533333rem
			background url(../assets/img/4.png) no-repeat
			background-size cover
			margin 0.533333rem auto 0 auto
			.logo{
				width 4.24rem
				height 0.613333rem
				background url(../assets/img/5.png) no-repeat
				background-size contain
				float left
			}
			.count{
				background url(../assets/img/6.png) no-repeat
				background-size 0.373333rem 0.373333rem
				font-size: 0.32rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #794313;
				line-height: 0.32rem;
				padding-left 0.48rem
				float right
			}
			.desc{
				clear both
				padding-top 0.533333rem
				max-height: 0.586666rem;
				font-size: 0.426666rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #794313;
				line-height: 0.586666rem;
				letter-spacing: 0.16rem;
			}
		}
		.content{
			background-color white
			border-top-left-radius 0.533333rem
			border-top-right-radius 0.533333rem
			margin-top -1.066666rem
			padding-top 0.266666rem
			.product{
				width: 8.933333rem;
				height: 1.866666rem;
				background: linear-gradient(270deg, rgba(255, 159, 98, 0.2) 0%, rgba(255, 242, 211, 0.1) 100%);
				border-radius: 0.213333rem;
				border: 0.026666rem solid #FD6A00;
				display flex
				align-items center
				justify-content space-between
				position relative
				.save{
					position absolute
					right 0
					top 0
					height: 0.453333rem;
					font-size: 0.32rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 0.453333rem;
					background: #FD6A00;
					border-radius: 0rem 0.213333rem 0rem 0.213333rem;
					padding 0rem 0.133333rem 0rem 0.133333rem
				}
				.product-title{
					margin 0.4rem
					font-size: 0.533333rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #77360D;
					line-height: 0.746666rem;
				}
				.right{
					display flex
					margin 0.4rem
					align-items center
					.price{
						font-size: 0.8rem;
						font-family: DINAlternate-Bold, DINAlternate;
						font-weight: bold;
						color: #FD6A00;
						line-height: 0.506666rem;
						margin 0.213333rem
						.unit{
							font-size 0.426666rem
						}
					}
					.original-price{
						font-size: 0.32rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #77360D;
						line-height: 0.453333rem;
						text-decoration line-through
					}
				}
			}
			.buy-botton{
				margin-top 0.533333rem
				width: 8.933333rem;
				height: 1.28rem;
				background: linear-gradient(90deg, #FEB040 0%, #FD6A00 100%);
				border-radius: 0.64rem;
				display flex
				justify-content center
				align-items center
				font-size: 0.426666rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 0.586666rem;
			}
			.agree{
				margin-top 0.266666rem
				font-size: 0.293333rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #989EA4;
				line-height: 0.586666rem;
				margin-bottom 0.4rem
				&>>>span{
					color red
				}
			}
			.sub-title{
				margin-top -0.266666rem
				.quotation{
					background url(../assets/img/7.png) no-repeat
					width 0.586666rem
					height 0.48rem
					background-size contain
					position absolute
					left -0.266666rem
					top -0.133333rem
				}
			}
			.lesson{
				border-radius: 0.32rem;
				margin-bottom 0.266666rem
				padding 0.32rem
				display flex
				.lesson-photo{
					flex-shrink 0
					width 1.2rem
					height 1.866666rem
					background-size contain
					margin-right 0.266666rem
					background-repeat no-repeat
				}
				.lesson-title{
					font-size: 0.4rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #2D363E;
					line-height: 0.426666rem;
					margin-bottom 0.266666rem
					margin-right 0.32rem
				}
				.lesson-desc{
					font-size: 0.373333rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #6C7275;
					line-height: 25px;
					margin-right 0.32rem
				}
				&.lesson-a{
					margin-top 0.4rem
					background: linear-gradient(90deg, #FFFFFF 0%, #FFF4ED 100%);
					.lesson-photo{
						background-image url(../assets/img/8.png)
					}
				}
				&.lesson-b{
					background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #F3F1FF 100%);
					.lesson-photo{
						background-image url(../assets/img/9.png)
					}
				}
				&.lesson-c{
					background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #EBF9F1 100%);
					.lesson-photo{
						background-image url(../assets/img/10.png)
					}
				}
				&.lesson-d{
					margin-bottom 0.533333rem
					background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #EEF6FF 100%);
					.lesson-photo{
						background-image url(../assets/img/11.png)
					}
				}
			}
			.ais{
				overflow hidden
				position relative
				padding-bottom 0.8rem
				.ai{
					width: 7.066666rem;
					height: 1.813333rem;
					display flex
					align-items center
					margin-bottom 0.266666rem
					.ai-photo{
						margin-left 0.186666rem
						height 0.906666rem
						width 0.906666rem
						background-repeat no-repeat
						background-size contain
						margin-right 0.32rem
					}
					.ai-desc{
						font-size: 0.4rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #2D363E;
						line-height: 0.693333rem;
						margin-right 0.186666rem
					}
					&.ai-a{
						background: #FFF5E7;
						border-radius: 0.32rem 0.32rem 0.32rem 0.106666rem;
						.ai-photo{
							background-image url(../assets/img/12.png)
						}
					}
					&.ai-b{
						background: #F1EFFD;
						border-radius: 0.32rem 0.32rem 0.106666rem 0.32rem;
						.ai-photo{
							background-image url(../assets/img/13.png)
						}
						float right
					}
					&.ai-c{
						background: #FFEBEC;
						border-radius: 0.32rem 0.32rem 0.32rem 0.106666rem;
						.ai-photo{
							background-image url(../assets/img/14.png)
						}
					}
				}
				.automan{
					width 2.08rem
					height 2.4rem
					background-image url(../assets/img/15.png)
					background-size contain
					position absolute
					right 0
					bottom -0.053333rem
				}
			}
			.rights{
				border-radius: 0.32rem;
				width 8.933333rem
				margin auto
				margin-bottom 0.533333rem
				background: #FFFCFA;
				box-shadow #FFBB76 0rem 0rem 0.053333rem
				thead{
					font-size: 0.4rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #915D36;
					line-height: 0.4rem;
				}
				td,th{
					height 1.066666rem
					text-align center
					vertical-align middle
				}
				th.vip{
					font-size: 0.48rem
					font-weight: 600;
					color: #FD6A00;
				}
				th.normal{
					color: #FE962B;
				}
				tr td:first-child{
					font-size: 0.373333rem;
					color: #915D36;
				}
				span{
					display inline-block
					width 0.64rem
					height 0.64rem
					background-size contain
					&.right{
						background-image url(../assets/img/16.png)
					}
					&.wrong{
						background-image url(../assets/img/17.png)
					}
				}
				th{
					background: #FFE6D6;
				}
				tr:first-child th:first-child{
					border-top-left-radius: 0.32rem
				}
				tr:first-child th:last-child{
					border-top-right-radius: 0.32rem
				}
				tr.even td{
					background #FFF6EE
				}
				tr:last-child td:first-child{
					border-bottom-left-radius: 0.32rem
				}
				tr:last-child td:last-child{
					border-bottom-right-radius: 0.32rem
				}
				td:last-child{
					font-size: 0.373333rem;
					font-weight: 400;
					color: #FE962B;
				}
			}
			.comments{
				margin-bottom 2.14rem
				.item{
					.user-profile{
						display flex
						.user-avatar{
							width 2.933333rem
							height 2.933333rem
							background-color #007AFF
							border-radius 0.266666rem
							img{
								width 2.933333rem
								height 2.933333rem
								border-radius 0.266666rem
							}
						}
						.user-info{
							margin 0 0.533333rem
							.name{
								font-size: 0.48rem;
								font-family: PingFangSC-Medium, PingFang SC;
								font-weight: 500;
								color: #2D363E;
								height: 0.533333rem
								line-height 0.533333rem
								overflow hidden
								margin-top 0.266666rem
								margin-bottom 0.64rem
							}
							.country{
								background-image url(../assets/img/18.png)
								background-repeat no-repeat
								background-size 0.426666rem 0.426666rem
								background-position left center
								padding-left 0.586666rem
								font-size: 0.426666rem;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #6C7275;
								line-height: 0.426666rem;
								margin-bottom 0.48rem
							}
							.time{
								background-image url(../assets/img/19.png)
								background-repeat no-repeat
								background-size 0.426666rem 0.426666rem
								background-position left center
								padding-left 0.586666rem
								font-size: 0.426666rem;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #6C7275;
								line-height: 0.426666rem;
								& >>> .light{
									color #FD6A00
								}
							}
						}
					}
					.learn-info{
						width: 7.6rem
						height: 1.333333rem;
						background: linear-gradient(180deg, #FFF5E8 0%, rgba(254, 172, 43, 0) 100%);
						border-radius: 0.32rem 0.32rem 0rem 0rem;
						margin-top 0.32rem
						display flex
						justify-content space-between
						align-items center
						.desc{
							padding 0rem 0.32rem
							font-size: 0.426666rem;
							font-family: DINAlternate-Bold, DINAlternate;
							font-weight: bold;
							color: #FD6A00;
							line-height: 0.373333rem;
							.learn-title{
								font-size: 0.373333rem;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #6C7275;
								line-height: 0.373333rem;
								margin-bottom 0.133333rem
							}
						}
						.up-to{
							width 0.693333rem
							height 0.48rem
							background url(../assets/img/20.png) no-repeat
							background-size contain
						}
					}
					.comment-content{
						width: 6.96rem;
						height: 3.146666rem;
						background: #F8F8F9;
						box-shadow: 0px 0.026666rem 0px 0px #FFFFFF;
						border-radius: 0.32rem
						font-size: 0.373333rem
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #6C7275;
						line-height: 0.533333rem
						padding 0.32rem
						overflow scroll
					}
				}
			}
		}
		.bottom {
			position fixed
			bottom 0
			height 1.733333rem
			width 100%
			background-color white
			box-shadow orange 0 0 0.213333rem
			.buy{
				.limit{
					height: 0.853333rem;
					background: #FFE2E3;
					display flex
					justify-content space-between
					align-items center
					padding 0rem 0.533333rem
					.limit-desc{
						font-size: 0.4rem;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #F85959;
						line-height: 0.56rem;
					}
					.time{
						display flex
						align-items center
						.ico{
							width 0.48rem
							height 0.48rem
							background-image url(../assets/img/22.png)
							background-size contain
							margin 0.186666rem
							display inline-block
						}
						font-size: 0.453333rem;
						font-family: PingFangSC-Semibold, PingFang SC;
						font-weight: 600;
						color: #F85959;
						line-height: 0.64rem;
					}
				}
				.product{
					margin-top 0.24rem
					margin-left 0.533333rem
					margin-right 0.533333rem
					display flex
					align-items center
					justify-content space-between
					.price{
						display flex
						align-items center
						font-size: 0.64rem;
						font-family: DINAlternate-Bold, DINAlternate;
						font-weight: bold;
						color: #FD6A00;
						line-height: 0.506666rem;
						.unit{
							font-size 0.426666rem
						}
						.original-price{
							margin 0.186666rem
							font-size: 0.32rem;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #6C7275;
							line-height: 0.453333rem;
						}
					}
					.buy-botton{
						width: 3.2rem;
						height: 1.306666rem;
						background: linear-gradient(90deg, #FEB040 0%, #FE862E 100%);
						border-radius: 0.666666rem;
						display flex
						justify-content center
						align-items center
						font-size: 0.4rem;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
						line-height: 0.56rem;
					}
				}
			}
		}
	}
	// 维语等右起特写
	.ug{
	   text-orientation: sideways;
	   direction: rtl;
	   .header-bg{
		   left 0
	   }
	   .card{
		   .desc{
			   letter-spacing:normal
		   }
	   }
	   .content{
		   .lesson{
			   .lesson-photo{
				   margin-right 0
			   }
		   }
		   .product{
			   
		   }
		   .ais{
			   .ai{
				   &.ai-a{
					   float left
					}
				   &.ai-b{
					}
				   &.ai-c{
					   float left
					}
			   }
		   }
		   .rights{
				tr:first-child th:first-child{
					border-top-right-radius: 0.32rem
					border-top-left-radius: 0
				}
				tr:first-child th:last-child{
					border-top-left-radius: 0.32rem
					border-top-right-radius: 0
				}
				tr:last-child td:first-child{
					border-bottom-right-radius: 0.32rem
					border-bottom-left-radius: 0
				}
				tr:last-child td:last-child{
					border-bottom-left-radius: 0.32rem
					border-bottom-right-radius: 0
				}
			}
		   .comments{
			direction: ltr;
		   	.item{
		   		.user-profile{
		   			.user-info{
						direction: rtl;
		   			}
		   		}
		   		.learn-info{
		   			.desc{
						direction: rtl;
		   			}
		   		}
		   		.comment-content{
					direction: rtl;
		   		}
		   	}
		   }
	   }
	}
</style>